/**
 * @generated SignedSource<<67b41e2455cd7960471ef613fdf56962>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PublisherReportTable_site$data = {
  readonly reportPublisher: any;
  readonly " $fragmentType": "PublisherReportTable_site";
};
export type PublisherReportTable_site = PublisherReportTable_site$data;
export type PublisherReportTable_site$key = {
  readonly " $data"?: PublisherReportTable_site$data;
  readonly " $fragmentSpreads": FragmentRefs<"PublisherReportTable_site">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "input"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PublisherReportTable_site",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "input",
          "variableName": "input"
        }
      ],
      "kind": "ScalarField",
      "name": "reportPublisher",
      "storageKey": null
    }
  ],
  "type": "Site",
  "abstractKey": null
};

(node as any).hash = "f2bc7c05335dd691fb5c7d5de483e3b4";

export default node;
